import React from "react";

export function ScrollArrow() {
  return (
    <svg
      width="64"
      height="24"
      viewBox="0 0 64 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Arrow 4"
        d="M63.0607 13.0607C63.6464 12.4749 63.6464 11.5251 63.0607 10.9393L53.5147 1.3934C52.9289 0.807616 51.9792 0.807616 51.3934 1.3934C50.8076 1.97919 50.8076 2.92894 51.3934 3.51472L59.8787 12L51.3934 20.4853C50.8076 21.0711 50.8076 22.0208 51.3934 22.6066C51.9792 23.1924 52.9289 23.1924 53.5147 22.6066L63.0607 13.0607ZM-1.31134e-07 13.5L62 13.5L62 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z"
        fill="#E6E6E6"
      />
    </svg>
  );
}
